export default __webpack_public_path__ + "static/product-smart-hose-timer-8cd5dd1f99d372c25ef48c4572410579.png";